/**
 * Room Management Constants and Utilities
 */
import { Wifi, Tv, Wind, Coffee, Bath, Car, Utensils, Dumbbell, Waves, Sparkles } from 'lucide-react';

// Icon mapping for amenities
export const amenityIcons = {
  wifi: Wifi,
  tv: Tv,
  ac: Wind,
  coffee: Coffee,
  bath: Bath,
  parking: Car,
  restaurant: Utensils,
  gym: Dumbbell,
  pool: Waves,
  other: Sparkles,
};

// Icon options for amenity form
export const iconOptions = [
  { value: 'wifi', label: 'WiFi', icon: Wifi },
  { value: 'tv', label: 'TV', icon: Tv },
  { value: 'ac', label: 'Air Conditioning', icon: Wind },
  { value: 'coffee', label: 'Coffee/Tea', icon: Coffee },
  { value: 'bath', label: 'Bathroom', icon: Bath },
  { value: 'parking', label: 'Parking', icon: Car },
  { value: 'restaurant', label: 'Restaurant', icon: Utensils },
  { value: 'gym', label: 'Gym', icon: Dumbbell },
  { value: 'pool', label: 'Pool', icon: Waves },
  { value: 'other', label: 'Other', icon: Sparkles },
];

// Get amenity icon by name
export const getAmenityIcon = (iconName) => amenityIcons[iconName] || Sparkles;

// Get status badge color class
export const getStatusColor = (status) => {
  switch (status) {
    case 'available': return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    case 'occupied': return 'bg-rose-100 text-rose-700 border-rose-200';
    case 'maintenance': return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'reserved': return 'bg-blue-100 text-blue-700 border-blue-200';
    default: return 'bg-gray-100 text-gray-700 border-gray-200';
  }
};

// Initial form data templates
export const initialRoomFormData = {
  room_number: '',
  room_type_id: '',
  block_name: '',
  floor: '',
  capacity: '',
  smoking_allowed: false,
  amenity_ids: [],
  photos: [],
  room_size: '',
  room_size_unit: 'sqft',
  override_adults: '',
  override_children: '',
  max_adults: '',
  max_children: ''
};

export const initialBulkFormData = {
  room_ranges: '',
  room_type_id: '',
  block_name: '',
  floor_prefix: true,
  smoking_allowed: false
};

export const initialPricingFormData = {
  name: '',
  room_type_id: '',
  bed_type_ids: [],
  amenity_ids: [],
  base_price: '',
  breakfast_price: '',
  lunch_price: '',
  dinner_price: '',
  is_active: true
};

export const initialRoomTypeFormData = {
  name: '',
  description: ''
};

export const initialAmenityFormData = {
  name: '',
  icon: 'other',
  description: ''
};

export const initialBedTypeFormData = {
  name: '',
  description: ''
};
